import { S2DUser } from "../../models/api/safe2DriveAdmin/staff";
import { type EditStaffMemberDto } from "../../models/app/safe2DriveAdmin/staff";
import { addStaffMemberValidationSchema } from "../AddStaffMember/AddStaffMemberFormValues";

// fileSafe claims left as part of the edit schema but will use a different endpoint on submit
export const editStaffMemberValidationSchema = addStaffMemberValidationSchema;

// roles are an array in the data shape, but only a single string is required by forms
export type EditStaffMemberFormValues = Omit<EditStaffMemberDto, "roles"> & { roles: S2DUser };
